import { CheckboxChecked, CheckboxEmpty, CheckboxIndeterminate } from '@ori-ui/icons';
import { colors } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const styleOverrides = {
  root: {
    color: colors.text.disabled
  }
};
const defaultProps = {
  icon: /*#__PURE__*/_jsx(CheckboxEmpty, {}),
  indeterminateIcon: /*#__PURE__*/_jsx(CheckboxIndeterminate, {}),
  checkedIcon: /*#__PURE__*/_jsx(CheckboxChecked, {})
};
export default {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiCheckbox.js.map